import React, { useMemo } from 'react';
import './MenaWinnerPage.css';
import FlashcardGame from './FlashcardGame';

const AUDIO_GUIDE_SRC = `${process.env.PUBLIC_URL || ''}/Mastering_Your_Mini_F11_Hologram_Fan_Prize.m4a`;

const FILE_LIBRARY = [
    { type: 'docs', label: 'PC software Download.txt', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2FPC%20software%20Download.txt' },
    { type: 'docs', label: 'README.txt', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2FREADME.txt' },
    { type: 'software', label: '5D_PC_Software.zip', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F5D_PC_Software.zip' },
    { type: 'bin', label: '00_000bc.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F00_000bc.bin' },
    { type: 'bin', label: '03_00new.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F03_00new.bin' },
    { type: 'bin', label: 'balloons.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fballoons.bin' },
    { type: 'bin', label: '300.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F300.bin' },
    { type: 'bin', label: '301a_div_fball.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F301a_div_fball.bin' },
    { type: 'bin', label: '301n_303.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F301n_303.bin' },
    { type: 'bin', label: '303_div-chess1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F303_div-chess1.bin' },
    { type: 'bin', label: '307.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F307.bin' },
    { type: 'bin', label: '308-310.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F308-310.bin' },
    { type: 'bin', label: '314-318.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F314-318.bin' },
    { type: 'bin', label: '318_div_planet.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F318_div_planet.bin' },
    { type: 'bin', label: '319-317.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F319-317.bin' },
    { type: 'bin', label: '319b_div_squaredogmusic.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F319b_div_squaredogmusic.bin' },
    { type: 'bin', label: '320-321.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F320-321.bin' },
    { type: 'bin', label: '320b_div_band.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F320b_div_band.bin' },
    { type: 'bin', label: '321.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F321.bin' },
    { type: 'bin', label: '321b_div_ffa1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F321b_div_ffa1.bin' },
    { type: 'bin', label: '322n_302.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F322n_302.bin' },
    { type: 'bin', label: '326-328.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F326-328.bin' },
    { type: 'bin', label: '326b_div_Firefly2vi.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F326b_div_Firefly2vi.bin' },
    { type: 'bin', label: '329-330.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F329-330.bin' },
    { type: 'bin', label: '330b_div_pinkbear.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F330b_div_pinkbear.bin' },
    { type: 'bin', label: '331-332-33.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F331-332-33.bin' },
    { type: 'bin', label: '331b_div_spin1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F331b_div_spin1.bin' },
    { type: 'bin', label: '333-334-33.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F333-334-33.bin' },
    { type: 'bin', label: '335_div_spacedog.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F335_div_spacedog.bin' },
    { type: 'bin', label: '336-337.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F336-337.bin' },
    { type: 'bin', label: '337b_div_guitar1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F337b_div_guitar1.bin' },
    { type: 'bin', label: '339_div_botbot.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F339_div_botbot.bin' },
    { type: 'bin', label: '342.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F342.bin' },
    { type: 'bin', label: 'bluebear-a.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fbluebear-a.bin' },
    { type: 'bin', label: 'bluebear.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fbluebear.bin' },
    { type: 'bin', label: 'cafe.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fcafe.bin' },
    { type: 'bin', label: 'clockw1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fclockw1.bin' },
    { type: 'bin', label: '400a-411a.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F400a-411a.bin' },
    { type: 'bin', label: '400a_div_soravid.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F400a_div_soravid.bin' },
    { type: 'bin', label: '400b-411b.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F400b-411b.bin' },
    { type: 'bin', label: '400b_div_sorauni.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F400b_div_sorauni.bin' },
    { type: 'bin', label: '408_div_diamond.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F408_div_diamond.bin' },
    { type: 'bin', label: '409-418.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F409-418.bin' },
    { type: 'bin', label: '409b_div_sora_bird.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F409b_div_sora_bird.bin' },
    { type: 'bin', label: '410_div_girldancem.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F410_div_girldancem.bin' },
    { type: 'bin', label: '419-432.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F419-432.bin' },
    { type: 'bin', label: '419b_div_bird.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F419b_div_bird.bin' },
    { type: 'bin', label: '433-438.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F433-438.bin' },
    { type: 'bin', label: 'cupid.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fcupid.bin' },
    { type: 'bin', label: 'dog1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fdog1.bin' },
    { type: 'bin', label: 'dog2.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fdog2.bin' },
    { type: 'bin', label: 'dog3.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fdog3.bin' },
    { type: 'bin', label: 'fb1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Ffb1.bin' },
    { type: 'bin', label: 'flowers1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fflowers1.bin' },
    { type: 'bin', label: '438b_div_jumprope.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F438b_div_jumprope.bin' },
    { type: 'bin', label: '439-451.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F439-451.bin' },
    { type: 'bin', label: '439b_div_puppy.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F439b_div_puppy.bin' },
    { type: 'bin', label: '452-466.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F452-466.bin' },
    { type: 'bin', label: '452b_div_sora.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F452b_div_sora.bin' },
    { type: 'bin', label: 'girldancem.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fgirldancem.bin' },
    { type: 'bin', label: 'heart1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fheart1.bin' },
    { type: 'bin', label: 'hnybaby.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fhnybaby.bin' },
    { type: 'bin', label: 'jumprope.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fjumprope.bin' },
    { type: 'bin', label: '467.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F467.bin' },
    { type: 'bin', label: '467b_div_dragride.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F467b_div_dragride.bin' },
    { type: 'bin', label: '468.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2FMena-bin%2F468.bin' },
    { type: 'bin', label: 'mf1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fmf1.bin' },
    { type: 'bin', label: 'orb.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Forb.bin' },
    { type: 'bin', label: 'parachute.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fparachute.bin' },
    { type: 'bin', label: 'poker1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fpoker1.bin' },
    { type: 'bin', label: 'rephands.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Frephands.bin' },
    { type: 'bin', label: 'soccerb.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fsoccerb.bin' },
    { type: 'bin', label: 'torus1.bin', href: 'https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Ftorus1.bin' }
];

const typeLabels = {
    docs: 'Manuals & Notes',
    software: 'Software & Utilities',
    bin: 'BIN Animations'
};

const typeOrder = ['docs', 'software', 'bin'];

const MenaWinnerPage = () => {
    const groupedFiles = useMemo(() => {
        const grouped = FILE_LIBRARY.reduce((acc, file) => {
            const { type } = file;
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(file);
            return acc;
        }, {});

        return typeOrder
            .filter((type) => grouped[type])
            .map((type) => ({
                type,
                label: typeLabels[type] || type,
                items: grouped[type].slice().sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
            }));
    }, []);

    return (
        <main className="mena-winner" id="mena-winner-top">
            <section className="mena-winner__intro">
                <div className="mena-winner__eyebrow">NYX NoCode Hackathon</div>
                <h1>Mena Hologram Fan Toolkit</h1>
                <p>
                    Everything you need to master the Mini F11 hologram fan lives here&mdash;from the story behind
                    the prize to every animation and software package we have released so far.
                    Load up to 50 BIN files on the fan at once, then swap in the extras whenever you want to remix the show.
                </p>
                <p className="mena-winner__status">
                    Heads up: the included microSD card arrives completely full so the prize playlist runs immediately.
                    Make sure to copy the card before deleting anything to free up slots.
                </p>
            </section>

            <section className="mena-winner__quickstart" aria-labelledby="quickstart-title" id="quickstart-section">
                <h2 id="quickstart-title">Super Simple Getting Started</h2>
                <figure className="mena-winner__unboxing">
                    <img src="/unboxing.jpeg" alt="Box contents of the hologram fan prize" loading="lazy" />
                    <figcaption>Everything in the Mystery Container—fan, cover, stand, remote, USB adapter, and instructions.</figcaption>
                </figure>
                <p>
                    It&apos;s tricky to capture hologram fans in photos because camera frame rates fight the spinning LEDs, so here are two quick demo clips:
                </p>
                <div className="mena-winner__demo-grid">
                    <video
                        className="mena-winner__demo-video"
                        controls
                        preload="none"
                        poster="/NYX_NoCode-600.webp"
                    >
                        <source src="https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fdemo_hologram_video.mov" type="video/quicktime" />
                        <p>Your browser may not support embedded MOV files. <a href="https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fdemo_hologram_video.mov" target="_blank" rel="noopener noreferrer">Watch the video</a>.</p>
                    </video>
                    <video
                        className="mena-winner__demo-video"
                        controls
                        preload="none"
                        poster="/NYX_NoCode-300.webp"
                    >
                        <source src="https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fhologram_demo_clip2.mov" type="video/quicktime" />
                        <p>Your browser may not support embedded MOV files. <a href="https://drive.nyx.baby/nyxnocode/kilroy%40uark.edu%2Fhologram_demo_clip2.mov" target="_blank" rel="noopener noreferrer">Watch the video</a>.</p>
                    </video>
                </div>
                <ol className="mena-winner__quickstart-steps">
                    <li>
                        <div className="mena-winner__quickstart-item">
                            <span className="mena-winner__quickstart-icon" aria-hidden="true">✦</span>
                            <span><strong>Open the box:</strong> The hologram fan is inside its case with a USB cord already attached. Plug that cord into any USB power source and the fan turns on immediately.</span>
                        </div>
                    </li>
                    <li className="mena-winner__quickstart-warning">
                        <div className="mena-winner__quickstart-item">
                            <span className="mena-winner__quickstart-icon" aria-hidden="true">⚠</span>
                            <span><strong>Safety Check:</strong> TO PREVENT BREAKAGE OR INJURY, MAKE SURE THE COVER IS IN PLACE ANYTIME THE FAN IS PLUGGED IN.</span>
                        </div>
                    </li>
                    <li>
                        <div className="mena-winner__quickstart-item">
                            <span className="mena-winner__quickstart-icon" aria-hidden="true">✦</span>
                            <span><strong>Instant showtime:</strong> That’s all you need to watch. Assemble the stand if you want to set the fan at a tilt for better viewing.</span>
                        </div>
                    </li>
                    <li>
                        <div className="mena-winner__quickstart-item">
                            <span className="mena-winner__quickstart-icon" aria-hidden="true">✦</span>
                            <span><strong>Remote control:</strong> Use it to toggle sound, move forward/backward through images, repeat, brighten or dim, and pause playback.</span>
                        </div>
                    </li>
                    <li>
                        <div className="mena-winner__quickstart-item">
                            <span className="mena-winner__quickstart-icon" aria-hidden="true">✦</span>
                            <span><strong>Make it “float”:</strong> Reflect the fan in a magnifying mirror larger than the blade to get a bigger, floating effect in bright or dark rooms.</span>
                        </div>
                    </li>
                    <li>
                        <div className="mena-winner__quickstart-item">
                            <span className="mena-winner__quickstart-icon" aria-hidden="true">✦</span>
                            <span><strong>Explore the files:</strong> The included USB adapter lets you connect the fan’s SD card—where all the images live—to your computer.</span>
                        </div>
                    </li>
                    <li>
                        <div className="mena-winner__quickstart-item">
                            <span className="mena-winner__quickstart-icon" aria-hidden="true">✦</span>
                            <span><strong>Need more info?</strong> Check the factory instruction sheet tucked into the box for additional details.</span>
                        </div>
                    </li>
                </ol>
            </section>

            <section className="mena-winner__audio" aria-labelledby="audio-guide-title" id="audio-section">
                <div>
                    <h2 id="audio-guide-title">Listen: Mastering Your Mini F11 Hologram Fan Prize</h2>
                    <p>
                        Stream our guided tour for tips on curating your playlist, installing the PC editor,
                        and making the most of the motion-triggered display.
                    </p>
                </div>
                <audio controls preload="none" src={AUDIO_GUIDE_SRC}>
                    <source src={AUDIO_GUIDE_SRC} type="audio/mp4" />
                    <source src={AUDIO_GUIDE_SRC} type="audio/m4a" />
                    Your browser does not support the audio element. Download the guide file and listen locally.
                </audio>
            </section>

            <section className="mena-winner__guide" aria-labelledby="quick-start-title" id="guide-section">
                <h2 id="quick-start-title">Your New Hologram Fan: A Winner’s Quick-Start Guide</h2>
                <aside className="mena-winner__specs">
                    <h3>Specification</h3>
                    <dl>
                        <div>
                            <dt>Model</dt>
                            <dd>Fursol portable/desktop 3.46&quot; (11cm) holographic fan</dd>
                        </div>
                        <div>
                            <dt>Speaker</dt>
                            <dd>Built-in for synchronized audio</dd>
                        </div>
                        <div>
                            <dt>Materials</dt>
                            <dd>ABS, PC, acrylic</dd>
                        </div>
                        <div>
                            <dt>Cover</dt>
                            <dd>Fully transparent casing</dd>
                        </div>
                        <div>
                            <dt>Display diameter</dt>
                            <dd>Approx. 8cm</dd>
                        </div>
                        <div>
                            <dt>Product diameter</dt>
                            <dd>Approx. 11cm</dd>
                        </div>
                        <div>
                            <dt>Resolution</dt>
                            <dd>450 × 224 dpi</dd>
                        </div>
                        <div>
                            <dt>LED count</dt>
                            <dd>48 LEDs, ~100,000 hour lifespan</dd>
                        </div>
                        <div>
                            <dt>Supported formats</dt>
                            <dd>MP4, AVI, GIF, JPG, PNG, RMVB</dd>
                        </div>
                        <div>
                            <dt>Content updates</dt>
                            <dd>Wi-Fi + companion apps</dd>
                        </div>
                        <div>
                            <dt>Storage</dt>
                            <dd>Built-in 8 GB memory card</dd>
                        </div>
                        <div>
                            <dt>Power</dt>
                            <dd>USB DC 5V/2A (1–6 W draw)</dd>
                        </div>
                        <div>
                            <dt>Input</dt>
                            <dd>USB DC 5V/2A</dd>
                        </div>
                    </dl>
                </aside>
                <ol className="mena-winner__guide-list">
                    <li>
                        <h3>Celebrating Your Achievement</h3>
                        <p>
                            Congratulations on conquering the NYX NoCode Hackathon in the Mena School District. This fan is not a novelty;
                            it is a hardware canvas that blurs the line between high-speed engineering and digital storytelling. Every time
                            you load a BIN file you are operating as a hardware artist, translating code into light.
                        </p>
                        <p>
                            Treat the device like professional gear. Learning how to manipulate the blade, LEDs, and firmware means you are
                            stepping into the world of physical computing where imagination meets mechanical precision.
                        </p>
                    </li>
                    <li>
                        <h3>Audit the Kit Like a Systems Engineer</h3>
                        <p>Confirm every component before you power up:</p>
                        <ul className="mena-winner__checklist">
                            <li><span aria-hidden="true">✔</span> Hologram fan with pre-attached USB power cord and SD-card slot.</li>
                            <li><span aria-hidden="true">✔</span> Protective cover that locks in place over the blade.</li>
                            <li><span aria-hidden="true">✔</span> Remote control for brightness, playlists, audio, and playback.</li>
                            <li><span aria-hidden="true">✔</span> Mounting stand engineered for the proper display angle.</li>
                            <li><span aria-hidden="true">✔</span> USB adapter for shuttling BIN files to the card.</li>
                            <li><span aria-hidden="true">✔</span> Instruction sheet for the precise model configuration.</li>
                        </ul>
                        <p>Think of the kit as an ecosystem—each element overlaps to deliver safety, data flow, and stability.</p>
                    </li>
                    <li>
                        <h3>The Science of Illusion</h3>
                        <p>
                            The fan works by using persistence-of-vision. A single blade spins at incredible speed while LEDs pulse in micro-second
                            bursts. Your brain stitches those flashes into a floating image, the same way a bright afterimage lingers on a blank wall.
                            Understanding that neurology lets you design frames that hold together mid-air.
                        </p>
                    </li>
                    <li>
                        <h3>Initial Setup &amp; Safety</h3>
                        <p>
                            Golden rule: install and lock the protective cover before connecting the USB cord to any power source.
                            Place the stand on a soft, textured surface (mouse pad, towel) to absorb vibration so the blade stays level and safe.
                        </p>
                    </li>
                    <li>
                        <h3>Interface Protocols</h3>
                        <p>
                            Use the remote to mute audio, loop clips, flip through files, or tune brightness for the room. The fan announces
                            “Bluetooth connecting” at startup—pair it with an external speaker but always start at the lowest volume, then ramp
                            up gradually for synchronicity. Try aiming the projection into a large mirror to magnify the stage and create deeper immersion.
                        </p>
                    </li>
                    <li>
                        <h3>Content Management &amp; Software</h3>
                        <p>
                            The microSD card (4GB installed, larger supported) caps active playlists at 50 BIN files. Back up the card before deleting.
                            When adding new content, you can:
                        </p>
                        <ul className="mena-winner__software-list">
                            <li>
                                <span aria-hidden="true">▶</span>
                                <span><strong>5D Displayer (iPhone):</strong> Wi-Fi uploads with live progress ring. Ignore false “failure” notices—check the fan.</span>
                            </li>
                            <li>
                                <span aria-hidden="true">▶</span>
                                <span><strong>5D Hollow (PC):</strong> Converts MP4s and images to BINs over Wi-Fi.</span>
                            </li>
                            <li>
                                <span aria-hidden="true">▶</span>
                                <span><strong>5D Displayer (PC):</strong> Fastest way to write straight to the SD card for bulk transfers.</span>
                            </li>
                        </ul>
                        <p>Always select the Mini F11 profile so the LED map matches, and insert the SD card into the USB adapter with the gold pins facing down.</p>
                    </li>
                    <li>
                        <h3>Collaborative Futures</h3>
                        <p>
                            This fan is your entry point into larger installations. Imagine linking multiple units with friends to stitch a synchronized
                            hologram wall. Keep learning, stay disciplined with safety, and you will move from user to innovator in the hardware + AI space.
                        </p>
                    </li>
                </ol>
                <p className="mena-winner__guide-outro">
                    Best wishes on your continued journey into modern digital media—this prize is just the beginning.
                </p>
            </section>

            <section id="flashcards-section" className="mena-winner__flashcards-wrapper">
                <FlashcardGame />
            </section>

            <section className="mena-winner__files" aria-labelledby="file-library-title" id="download-section">
                <h2 id="file-library-title">Download Library</h2>
                <p className="mena-winner__files-note">
                    Links are grouped by file type and sorted alphabetically so you can find what you need fast.
                    The fan ships with a rotating playlist; the rest are bonus animations ready to sideload.
                </p>

                {groupedFiles.map((group) => (
                    <div key={group.type} className="mena-winner__file-group">
                        <h3>{group.label}</h3>
                        <ul>
                            {group.items.map((item) => (
                                <li key={item.label}>
                                    <a href={item.href} target="_blank" rel="noopener noreferrer">
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </section>

            <section className="mena-winner__pro-tip" aria-labelledby="pro-tip-title" id="pro-tip-section">
                <div className="mena-winner__pro-tip-badge">Pro Tips</div>
                <div className="mena-winner__pro-tip-body">
                    <h2 id="pro-tip-title">Only 50 BIN files can run at once.</h2>
                    <p>
                        The Mini F11 firmware hard-caps playlists at 50 files. Rotate animations in sets, and keep your SD card labeled so
                        you can swap themes fast.
                    </p>
                    <ul className="mena-winner__pro-tip-list">
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>Preloaded prize playlist already fills the 50-slot limit.</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>Keep any extra files in labeled folders (e.g. <code>/Extras</code>).</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>Back up the SD card before overwriting live slots.</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>Use the included software to format a new SD card before storing BIN files on it.</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>MP4 movie files and most image files can be converted into BIN files using the included software.</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>Your fan can broadcast a Wi-Fi hotspot that only the 5D Holo app or 5D Displayer (iPhone) can join for direct transfers.</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>The Apple App Store version of 5D Displayer is the only tool that can play and delete songs directly on the fan.</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>Black backgrounds work best and become transparent once loaded on the hologram fan.</span>
                        </li>
                        <li>
                            <span aria-hidden="true">★</span>
                            <span>Use the 5D apps to rewrite batches and keep your show feeling fresh.</span>
                        </li>
                    </ul>
                    <div className="mena-winner__app-table">
                        <table>
                            <caption>5D App Capabilities</caption>
                            <thead>
                                <tr>
                                    <th>App</th>
                                    <th>Platform</th>
                                    <th>Uses Fan Wi-Fi Hotspot?</th>
                                    <th>Transfer Method</th>
                                    <th>Play/Delete on Fan?</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>5D Displayer</td>
                                    <td>iPhone / iOS</td>
                                    <td>Yes</td>
                                    <td>Uploads directly to the fan over the hotspot</td>
                                    <td>Yes – can preview and delete songs</td>
                                </tr>
                                <tr>
                                    <td>5D Holo</td>
                                    <td>PC</td>
                                    <td>Yes</td>
                                    <td>Wi-Fi transfers over the fan hotspot</td>
                                    <td>No</td>
                                </tr>
                                <tr>
                                    <td>5D Displayer</td>
                                    <td>PC</td>
                                    <td>No</td>
                                    <td>Writes files to local storage or SD card</td>
                                    <td>No</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <div className="mena-winner__back-top">
                <a href="#mena-winner-top">↑ Back to top</a>
            </div>
        </main>
    );
};

export default MenaWinnerPage;
